import { render, staticRenderFns } from "./recent-transactions.vue?vue&type=template&id=28caa5e8&scoped=true&"
import script from "./recent-transactions.vue?vue&type=script&lang=js&"
export * from "./recent-transactions.vue?vue&type=script&lang=js&"
import style0 from "./recent-transactions.vue?vue&type=style&index=0&id=28caa5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28caa5e8",
  null
  
)

export default component.exports